import { enumImportStep } from "../constants";
import { QApp } from "./QApp";
import { QStream } from "./QStream";
import { QXMLLoader } from "./QXMLLoader";

export class QAppendHandler {
  constructor() {
    this.fWSMgr = null;
    this.fFileList = [];
  }

  InitHandler(wsMgr) {
    this.fWSMgr = wsMgr;
  }

  GetExcelDataResult(success, theData, fileName, directory) {
    var w = this.fWSMgr;
    if (success) {
      var theDoc = w.GetDoc();

      var s = new QStream();
      s.InitStreamFromXML(theData);

      var loader = new QXMLLoader();
      var objTree = loader.LoadXML(s);
      theDoc.AppendDBFromXML(objTree);
    }
    var fileList = this.fFileList;
    fileList.pop();
    var result = w["importparam"];
    if (fileList.length == 0)
      w.AdvanceImport("creatingchart", enumImportStep.buildhier, result, null, null);
  }
}
